export default __webpack_public_path__ + "static/media/The Scimitar of Dunes.9afd4423.jpg";